/**
 * @generated SignedSource<<ddab049c99d29f9c37b88f4557507e5b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type RelationshipsListAllViewItemFragments$data = ReadonlyArray<{
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"RelationshipsListAllViewItemFragment">;
  readonly " $fragmentType": "RelationshipsListAllViewItemFragments";
}>;
export type RelationshipsListAllViewItemFragments$key = ReadonlyArray<{
  readonly " $data"?: RelationshipsListAllViewItemFragments$data;
  readonly " $fragmentSpreads": FragmentRefs<"RelationshipsListAllViewItemFragments">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "RelationshipsListAllViewItemFragments",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RelationshipsListAllViewItemFragment"
    }
  ],
  "type": "Issue",
  "abstractKey": null
};

(node as any).hash = "8590a74d55a0e1f39cf398ceb9731c6d";

export default node;
